import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageLayout from "../common/PageLayout";
import { BsFiles } from "react-icons/bs";
import { Grid, Box, TextField, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { AppEntryRepository } from "../repositories/AppEntryRepository";
import EntryTable from "../common/EntryTable";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import { notifyShowErrorMessage } from "../../store/AlertSlice";

export default function SubmittedEntries() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [searchParams, setSearchParams] = useState({
    status: "DONE",
  });
  const [orderBy, setOrderBy] = useState("dateCreated");
  const [data, setData] = useState();
  const [orderDirection, setOrderDirection] = useState("DESC");
  const dispatch = useDispatch();

  useEffect(() => {
    fetchData(0, 10);
  }, []);

  const fetchData = (page, size) => {
    setLoading(true);
    AppEntryRepository.getAll(page, size, searchParams, orderBy, orderDirection)
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(err)));
      });
  };

  const handleChangePage = (event, newPage) => {
    fetchData(newPage, data?.size);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    fetchData(0, newSize);
  };

  return (
    <PageLayout title="Завршени барања" Icon={BsFiles} prev={location.pathname}>
      <Grid container style={{ padding: "10px 0" }}>
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12} sm={2} md={2} lg={2}>
                <TextField
                  variant="outlined"
                  value={searchParams.entryNumber || ""}
                  onChange={(e) =>
                    setSearchParams({
                      ...searchParams,
                      entryNumber: e.target.value,
                    })
                  }
                  size="small"
                  fullWidth
                  label={"Број на запис"}
                  onKeyUp={(e) => e.key === "Enter" && fetchData(0, data?.size)}
                />
              </Grid>
              <Grid item xs={12} sm={2} md={2} lg={2}>
                <TextField
                  variant="outlined"
                  value={searchParams.trackingNumber || ""}
                  onChange={(e) =>
                    setSearchParams({
                      ...searchParams,
                      trackingNumber: e.target.value,
                    })
                  }
                  size="small"
                  fullWidth
                  label={"ИД за следење"}
                  onKeyUp={(e) => e.key === "Enter" && fetchData(0, data?.size)}
                />
              </Grid>
              <Grid item xs={12} sm={2} md={2} lg={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    fetchData(0, data?.size);
                  }}
                >
                  Пребарај
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <EntryTable
            data={data}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            loading={loading}
          />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
